import type { Language } from './components/LocalizationProvider';

export const COUNTRY_COOKIE = 'localization_country';
export const COUNTRY_HEADER = 'x-country';
export const LANGUAGE_HEADER = 'x-language';
export const DEFAULT_LOCALE: Language = 'en';
export const DEFAULT_COUNTRY = 'US';
export const GUEST_CART_ID_STORAGE_KEY = 'shop/guest-cart-id';
export const CART_ID_STORAGE_KEY = 'shop/cart-id';
export const CART_USER_TYPE_STORAGE_KEY = 'shop/cart-id-user-type';

/* Shop */
export const SHOP_STORE_CODE_COOKIE = 'store-view-code';
export const STORE_CODE_DEFAULT = 'usa_usd_en';

/* Routes  */
export const LANGUAGE_PARAM = ':language';

export const FEATURE_TOKEN_COOKIE = 'FEATURE_TOKEN';
export const FEATURE_TOKEN_HEADER = 'x-feature-token';
export const ACCESS_TOKEN_COOKIE = 'access-token';
export const STORE_CODE_HEADER = 'Store';

/* Algolia */
export const PRODUCTS_INDEX = 'products_izotope';
export const CONTENTS_INDEX = 'contents_izotope';

/* Cross-app communication */
export const EVENTS = {
  cartUpdated: 'cartUpdated',
  cartIdReady: 'cartIdReady',
  cartIdError: 'cartIdError',
};

export const SUBSCRIPTION_CADENCE = {
  yearly: '5481201400',
  monthly: '5481201500',
};
